import { useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { Loader } from "rsuite";

import AuthGabarit from "../../components/AuthGabarit";
import { InputEmail } from "../../components/Inputs";
import { useConfig } from "../../context/config-context";
import API from "../../utils/api";

export default function ValidateEmailPage() {
  const [loading, setLoading] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  let navigate = useNavigate();

  const siteConfig = useConfig();

  const onSubmit = async (data) => {
    try {
      setLoading(true);
      await API.post("/first-login", data);
      navigate(siteConfig.routes.login.path);
    } catch (error) {}
    setLoading(false);
  };

  return (
    <AuthGabarit DisplayLoginButton>
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="flex flex-col space-y-2"
      >
        <p className="text-sm">{siteConfig.pages.validate_email.label}</p>
        <InputEmail id="email" register={register} error={errors.email} />

        <button
          type="submit"
          className="px-10 py-1 mx-auto border rounded w-fit border-primary text-primary hover:bg-primary disabled:bg-transparent hover:text-white"
          disabled={loading}
        >
          {loading ? <Loader /> : siteConfig.pages.validate_email.cta}
        </button>
      </form>
    </AuthGabarit>
  );
}
